import { Component, Inject, Prop, Vue } from 'vue-property-decorator'
import { ConfigurationAssayLaboratoryResponse } from '@/modules/configurationModule/detail/local-assays/assays-laboratory/services/configuration-assay-laboratory/configuration-assay-laboratory.dto'
import { Validator } from 'vee-validate'
import { ConfigurationAssayResponse } from '@/modules/configurationModule/detail/assays/configuration-assays/services/configuration-assay/configuration-assay.dto'
import { configurationAssayService } from '@/modules/configurationModule/detail/assays/configuration-assays/services/configuration-assay/configuration-assay.service'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { GridUtils } from '@/shared/util/grid-utils'

@Component
export default class ConfigurationLocalAssaysAssaysLaboratoryModalBasicForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly assayLaboratory!: Partial<ConfigurationAssayLaboratoryResponse>

    @Inject() externalValidator!: Validator

    get updateMode(): boolean {
        return !!this.assayLaboratory?.id
    }

    private externalControlSelected!: any
    private externalControlOptions!: Array<object>
    private controlTypeSelected!: any
    private controlTypeOptions!: Array<object>

    constructor() {
        super()

        this.$validator = this.externalValidator

        // Mockup data for selector
        this.externalControlSelected = { value: 'a', text: this.$tc('configuration.grid.externalControlNotRequired') }
        this.externalControlOptions = [
            { value: 'a', text: this.$tc('configuration.grid.externalControlNotRequired') },
            { value: 'b', text: this.$tc('configuration.grid.externalControlRequired') },
            { value: 'c', text: this.$tc('configuration.grid.externalControlOptional') },
            { value: 'd', text: this.$tc('configuration.grid.externalControlOnDemand') }
        ]
        this.controlTypeSelected = { value: 'a', text: this.$tc('configuration.grid.controlTypeTissueControl') }
        this.controlTypeOptions = [
            { value: 'a', text: this.$tc('configuration.grid.controlTypeTissueControl') }
        ]
    }

    async getAssays(query: string): Promise<ConfigurationAssayResponse[]> {
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const filterModel: CommonFilterModel = {
            active: GridUtils.getSetFilterModel(['true']),
            name: GridUtils.getTextFilterModel('contains', query)
        }
        const response = await this.$_toCallUnique(configurationAssayService.paginator(filterModel, params))
        if (response) {
            return response.content
        }
        return []
    }

    getCustomLabel(assay: ConfigurationAssayResponse): string {
        return `${assay.name} - ${assay.assaygroup.name}`
    }
}
